import { Box, Typography, useTheme } from '@mui/material'
import { useFormik } from 'formik'
import { toast } from 'react-toastify'

import EditableTitle from '~/components/editableTitle'
import validationSchema from '~/features/agents/components/agentInfoHeader/agentNameInfo/utils'
import useGetAgentCentralized from '~/features/agents/hooks/useGetAgentCentralized'
import useUpdateAgent from '~/features/agents/hooks/useUpdateAgent'
import { EAgentKeys } from '~/features/agents/models'
import { ECapability } from '~/features/user/models'
import useCapabilities from '~/hooks/useCapabilities'
import rem from '~/utils/ui'

function AgentNameInfo() {
  const theme = useTheme()
  const { canEdit } = useCapabilities()
  const canEditAssistantName = canEdit(ECapability.aiAssistantConfig)
  const { selectedAgent: agent } = useGetAgentCentralized()

  const agentReferenceName = agent?.[EAgentKeys.agentReferenceName] || ''
  const agentId = agent?.[EAgentKeys.id] || ''
  const { mutate: updateAgent } = useUpdateAgent(agentId)

  const formik = useFormik({
    initialValues: {
      [EAgentKeys.agentReferenceName]: agentReferenceName || '',
    },
    enableReinitialize: true,
    validationSchema,
    onSubmit: (values) => {
      updateAgent(
        {
          payload: {
            agent: {
              [EAgentKeys.agentReferenceName]:
                values[EAgentKeys.agentReferenceName],
            },
          },
        },
        {
          onError: () => {
            toast.error('Error update agent')
          },
        },
      )
    },
  })

  return (
    <Box sx={{ width: { xxxs: '100%', lg: 'auto' } }}>
      <EditableTitle
        name={EAgentKeys.agentReferenceName}
        ariaLabel="Assistant name"
        disabled={!canEditAssistantName}
        value={formik.values.agentReferenceName}
        onChange={formik.handleChange}
        error={
          formik.touched.agentReferenceName &&
          Boolean(formik.errors.agentReferenceName)
        }
        helperText={
          formik.touched.agentReferenceName
            ? formik.errors.agentReferenceName
            : ''
        }
        onSubmit={formik.handleSubmit}
        sxInputProps={{
          '& .MuiInputBase-input': {
            fontSize: rem(16),
            color: theme.palette.mainFont,
            padding: 0,
            height: rem(30),
            width: { xxxs: '100%', lg: rem(300) },
          },
        }}
        sxTitleProps={{
          fontSize: rem(16),
          color: theme.palette.tertiary1,
          fontWeight: 700,
        }}
        sxIconProps={{
          alignSelf: 'flex-start',
          '& .MuiSvgIcon-root': {
            width: rem(14),
            height: rem(14),
            color: theme.palette.text.secondary,
          },
        }}
      />
      <Typography
        fontSize={rem(12)}
        fontWeight="normal"
        sx={{ mt: { xxxs: 1, lg: 0 } }}
      >
        Assistant contact info
      </Typography>
    </Box>
  )
}

export default AgentNameInfo
